const NumServices = require('../NumServices');
const LicenseInfo = require('../LicenseInfo');
const ReportService = require('../ReportService');
const View = require('../../../../../_lib/core/View');

class ReportView extends View {
  constructor(modal, btn) {
    super('report-modal');

    this.modal = modal;
    this.reportedTitles = [];
    this.reportService = new ReportService();

    this.submitAndViewEl = modal.find('button[name=submit-view]');
    this.submitAndStayEl = modal.find('button[name=submit-continue]');
    this.reprintNumServicesEl = modal.find('[name=reprint_num_services]');
    this.podcastNumServicesEl = modal.find('[name=podcast_num_services]');
    this.licenseTypeSelect = modal.find('.select-licenseType');
    this.licenseTypeContainer = modal.find('.license-type');
    this.graphicSourceSelect = modal.find('select#graphic_source');
    this.recordedAudioContainer = modal.find('.recorded-audio-container');
    this.serviceTracksSelect = modal.find('select#recorded_audio_service_tracks');
    this.practiceTracksSelect = modal.find('select#recorded_audio_practice_tracks');
    this.recordedTypeContainerEl = modal.find('.recorded-type-container');
    this.hasRecording = this.serviceTracksSelect.length || this.practiceTracksSelect.length;
    this.recordedAudioTypeCheckbox = modal.find('input[name=is_commercial]');
    this.weeksSelect = modal.find('.time-report');
    this.cancelEl = modal.find('#btnEditCancel');
    this.form = modal.find('form');

    this.currentButton = btn;
    this.buttonData = btn.data();

    this.numServices = new NumServices(this, this.reprintNumServicesEl, this.podcastNumServicesEl, this.recordedAudioContainer, this.serviceTracksSelect, this.practiceTracksSelect, this.recordedTypeContainerEl);
    this.licenseInfo = new LicenseInfo(this);
  }

  configureElements() {
    this.graphicSourceSelect.select2nonUnique({
      placeholder: __('Select Graphic Source'),
      minimumResultsForSearch: Infinity
    });
  }

  bindElements() {
    this.bind(this.submitAndViewEl, 'click', async (e) => {
      await this.onSubmitClick(e);
    });

    this.bind(this.submitAndStayEl, 'click', async (e) => {
      await this.onSubmitClick(e);
    });

    this.bind(this.cancelEl, 'click', (e) => {
      this.onCancelClick(e);
    })
  }

  async onSubmitClick(e) {
    const btn = $(e.currentTarget);
    const action = btn.data('action');
    const dataArr = this.getDataFromForm();

    localStorage.setItem('lastSelectedReprint', this.licenseInfo.getLicenseTypeVal());
    localStorage.setItem('lastSelectedWeek', this.licenseInfo.getWeeksVal());

    this.loading();

    await this.reportService.reportTitles(dataArr, this.reportedTitles, action)
      .success((data) => {
        this.onTitlesReported(action, data.link);
      })

    this.loading('reset');
  }

  onTitlesReported(action, link) {
    if (action === 'view' && link) {
      this.redirect(link);
    } else {
      $('.report-checkbox').attr('checked', false);
      this.hideModal();
    }
  }

  onCancelClick(e) {
    this.hideModal();

    e.preventDefault();
  }

  hideModal() {
    this.modal.modal('hide');
  }

  updateHeading(text) {
    this.modal.find('#heading').html(text);
  }

  getDataFromForm(key) {
    return this.getArrayOrKeyValue(this.form.serializeJson(), key);
  }

  getDataFromButton(key) {
    return this.getArrayOrKeyValue(this.buttonData, key);
  }

  getArrayOrKeyValue(array, key) {
    if (typeof key !== 'undefined') {
      return array[key];
    } else {
      return array;
    }
  }

  loading(mode) {
    const btn = this.modal.find('button');
    btn.loading(mode);
  }

  redirect(url) {
    window.location.href = url;
  }
}

module.exports = ReportView;
